import { GoalBF } from "../../models"

export const sortGoals = (goals: GoalBF[]): GoalBF[] => {
  const preferedOrder = [
    'PersonalMassage',
    'CoupleMassage',
    'PregnantMassage',
    'CompanyMassage',
    'Weightloss',
    'PersonalYoga',
    'PregnantYoga',
    'GroupYoga',
  ]
  const priorities = goals.map((goal, i) => {
    const indexFound = preferedOrder.indexOf(goal.name)
    const priority = indexFound === -1 ? Infinity : indexFound
    const originalIndex = i
    return {
      priority: priority,
      originalIndex: originalIndex,
    }
  })
  const sortedPriorities = priorities.sort((a, b) => {
    return a.priority - b.priority
  })
  const sortedGoals = sortedPriorities.map((g) => goals[g.originalIndex])
  return sortedGoals
}
